export const tours = {
    initialTour: 'initialTour',
    requestDetailsTour: 'requestDetailsTour',
    concludedRequestTour: 'concludedRequestTour',
    resolvePendingTour: 'resolvePendingTour',
    petitionIndicationTour: 'petitionIndicationTour',
    requestCorrectionTour: 'requestCorrectionTour',
    howToEditTour: 'howToEditTour',
};